<div class="table-responsive" *ngIf="mappedData; else loading">
  <table class="table table-striped">
    <tbody>
      <tr>
        <th translate>PRODUCT_ID</th>
        <th translate>NAME</th>
        <th *ngFor="let headerKey of headerDynamicTranslationKeys">{{ headerKey | translate }}</th>
        <th translate>AVAILABILITY</th>
        <th translate>PRICE</th>
        <th></th>
        <th></th>
      </tr>
      <tr *ngFor="let item of mappedData; index as i">
        <td>
          <a class="product-link" routerLink="{{ item.product.id }}">{{ item.product.extra.ar.artnr }}</a>
        </td>
        <td>
          {{ item.product.extra.ar.artbeskr }}
        </td>
        <td *ngFor="let value of item.dynamicCollumnsValues">{{ value }}</td>
        <td>
          <!-- if supplier stock is a neg #, indicates supplier stock is not null, otherwise show reg availability -->
          <div *ngIf="item.product?.extra?._levSaldoFromJeeves >= 0" style="color: green">
            <ng-container *ngIf="item.product.extra.pim?.['Leverantör']; else levStockNoSupplier">{{ 'STOCK_AT_LOCATION' | translate: { location: item.product.extra.pim['Leverantör'], value: item.product.extra._levSaldoFromJeeves } }}</ng-container>
            <ng-template #levStockNoSupplier>{{ 'IN_STOCK' | translate }} ({{ item.product.extra._levSaldoFromJeeves }})</ng-template>
          </div>
          <div *ngIf="item.product.extra._levSaldoFromJeeves === -1">
            <lib-availability
              *ngIf="item.availability"
              [availability]="item.availability"
              [product]="item.product"
              [isSales]="isSales"
            ></lib-availability>
          </div>
        </td>
        <td>
          <span *ngIf="item.price">
            <lib-price [price]="item.price" type="GROSS"></lib-price>
            <span *ngIf="item.price.customerDiscountPercent && item.price.customerDiscountPercent !== 0"
              >(-{{ item.price.customerDiscountPercent }}%)</span
            >
          </span>
        </td>
        <td>
          <sjoborg-buy-btn
            [id]="item.product.id"
            [minimumOrderQuantity]="getPackageSize(item.product)"
            [stepAmount]="getPackageSize(item.product)"
          >
          </sjoborg-buy-btn>
        </td>
        <td>
          <sjoborg-favourite-product [id]="item.product.id"></sjoborg-favourite-product>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</ng-template>
